import { useBulkDeployPageContext } from '../../../BulkDeployPageContext';

export default function useClusterMultiSelectProps() {
  const { setSelectedClusters } = useBulkDeployPageContext();

  return {
    setSelectedClusters,
    renderValue: selected => `Clusters (${selected.length})`,
  };
}
